import { BrowserRouter, Route, Routes } from "react-router-dom"

import Header from './components/Header';
import Home from './pages/Home';
import Filter from './pages/Filter';
import Manual from './pages/Manual';
import Result from './pages/Result';
import Sugestoes from './pages/Suggestions/index';
import MusicasSugeridas from './pages/MusicasMock';
import LocaisSugeridos from './pages/LocaisMock';
import LivrosSugeridos from './pages/LivrosMock';

const AppRoutes = ({ setModalContent }) => {
  return (
    <BrowserRouter>
      <div className="app-layout">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sugestoes" element={<Sugestoes />} />
          <Route path="/locais" element={<LocaisSugeridos />} />
          <Route path="/musicas" element={<MusicasSugeridas />} />
          <Route path="/livros" element={<LivrosSugeridos />} />
          <Route
            path="/manual"
            element={<Manual setModalContent={setModalContent} />}
          />

          <Route path="/filter" element={<Filter />} />
          <Route path="/filter/result" element={<Result />} />
        </Routes>
      </div>
    </BrowserRouter>
  )
}

export default AppRoutes
